<script>
    import {onMount} from 'svelte'
    import routerManager from './router'
    export let to;
    export let params = null;
    export let reload = false;
    let router;
    export let routerName = 'default'
    
    onMount(()=>{
        router = routerManager.getRouter(routerName)
    })
    
</script>
<div  on:click={()=> router.navigate(to,params,reload) } {...$$restProps}>    
    <slot/>
</div>